// extracted by mini-css-extract-plugin
export default {"kTextbox":"AgriculturalUseCategoriesOfLandTable_kTextbox__Suoo3","GreyedOut":"AgriculturalUseCategoriesOfLandTable_GreyedOut__asmoQ"};